import styled from 'styled-components';

const NavContainer = styled.nav`
  background: #c8102e;
  color: ${Styles.color.white};
  height: ${Styles.layout.navHeight.desktop};
  margin: 0 auto;
  padding: 30px;
`;

export default NavContainer;
